import { IconProps } from '.'
import BaseSvg from './BaseSvg'

// TODO Remove the onclick! Who's this Chris Weed jokester...
const Attach = ({ title = 'Attach', onClick, ...rest }: IconProps & { onClick: () => void }) => {
  return (
    <BaseSvg onClick={onClick} viewBox="0 0 32 32" title={title} {...rest}>
      <g strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2" stroke="currentColor">
        <path
          d="M28.967,16.524,18.053,27.437a8.85,8.85,0,0,1-12.457,0h0a8.85,8.85,0,0,1,0-12.457L16.841,3.736a6.19,6.19,0,0,1,8.6,0h0a6.191,6.191,0,0,1,0,8.6L14.967,22.807a3.2,3.2,0,0,1-4.63,0h0a3.2,3.2,0,0,1,0-4.63L20.368,7.925"
          fill="none"
          stroke="currentColor"
          strokeMiterlimit="10"
        />
      </g>
    </BaseSvg>
  )
}

Attach.needsWork = true
Attach.displayName = 'Attach'
export default Attach
